import SingleActiveOrder from "../../../Components/Admin/SingleActiveOrder";
const SingleActiveOrderPage = () => {
  return <SingleActiveOrder />;
};

export default SingleActiveOrderPage;
